function Config(){

}

Config.install = function (Vue, options) {
    let config = options.config[process.env.NODE_ENV + '.' + window.location.hostname]
    if(typeof config === 'undefined' ){
        config = options.config[process.env.NODE_ENV]
    }
    Vue.prototype.$config = config
}

Config.get = function(options) {
    let config = options.config[process.env.NODE_ENV + '.' + window.location.hostname]
    if(typeof config === 'undefined' ){
        config = options.config[process.env.NODE_ENV]
    } 
    return config
}

export default Config
